import { CURRENCY } from "./app-constants";
import { LANGUAGES } from "./language-constants";
import { PAYMENT_METHODS } from "./payment-methods";

export const PAYMENT_RULES = {
  [PAYMENT_METHODS.STRIPE]: {
    languages: [LANGUAGES.ENGLISH, LANGUAGES.VIETNAMESE, LANGUAGES.KOREAN],
    currencies: [CURRENCY.USD, CURRENCY.VND, CURRENCY.KRW]
  },
  [PAYMENT_METHODS.VNPAY]: {
    languages: [LANGUAGES.ENGLISH, LANGUAGES.VIETNAMESE],
    currencies: [CURRENCY.USD, CURRENCY.VND]
  },
  [PAYMENT_METHODS.IMP_PAYPAL]: {
    languages: [LANGUAGES.ENGLISH, LANGUAGES.KOREAN],
    currencies: [CURRENCY.USD]
  },
  [PAYMENT_METHODS.IMP_EXIMBAY]: {
    languages: [LANGUAGES.ENGLISH, LANGUAGES.KOREAN],
    currencies: [CURRENCY.USD, CURRENCY.KRW]
  },
  [PAYMENT_METHODS.PORT_ONE]: {
    languages: [LANGUAGES.ENGLISH, LANGUAGES.VIETNAMESE, LANGUAGES.KOREAN],
    currencies: [CURRENCY.USD, CURRENCY.VND, CURRENCY.KRW]
  },
  [PAYMENT_METHODS.PAYMENTWALL]: {
    languages: [LANGUAGES.ENGLISH, LANGUAGES.VIETNAMESE, LANGUAGES.KOREAN],
    currencies: [CURRENCY.USD]
  }
};